import * as React from "react";
import * as moment from "moment";
import Swiper from 'react-id-swiper';
import { api, user, guardAuth } from "src/services/api";
import { routeApi } from "src/services/browser";
import { classNames, __, __BETA, __TRIAL_DATE } from "src/services/theme";
import { alert, notify } from "src/services/notify";
import { FormState, Form, Fieldset, bindToAPI, resetState, _ } from "src/services/form";
import { Formatters, Loading, Modal, ImageEditor } from "src/components/ui";
import OrdineCheckout from "./OrdineCheckout";

import Free from "./AcquistiDocenteInfo/Free";
import Premium from "./AcquistiDocenteInfo/Premium";
import Adwords from "./AcquistiDocenteInfo/Adwords";
import Adsp from "./AcquistiDocenteInfo/Adsp";

interface Props {
  abbonamento: any;
  afterSign?: Function;
  onAdsp?: Function;
  onAdwords?: Function;
}

interface State {
  item?: any;
  phase: string;
  focus?: string;
  trialStatus?: "loading" | "active";
}

export default class AcquistiDocente extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      phase: "INDEX"
    };
  }

  async componentWillMount() {
    if (user) {
      const item = await api({
          url: routeApi('docente.show', { docente: user.id }),
          method: 'get'
      });
      this.setState({
        item,
        trialStatus: item.trial ? 'active' : undefined
      });
    }
  }
  
  focus( product ) {
    this.setState({
      focus: product
    });
  }
  
  continue( phase, args? ) {
    const {  } = this.state;
    
    const cb = () => {
      if (__BETA) {
        alert( { text: __('AcquistiDocente.coming_soon'), type: 'success' } );
        return;
      }
      if (phase === "ADSP") {
        const fn = `on${args.type === "ADSP" ? "Adsp" : "Adwords"}`;
        if (this.props[fn]) {
          this.props[fn]();
        }
      }
      if (phase === "TRIAL") {
        this.submitTrial();
        return;
      }
      this.setState({
        phase
      });
    }
    if (guardAuth(this.props.afterSign as any)) {
      cb();
    }
  }
  
  reset() {
    this.setState({
      phase: "INDEX"
    })
  }
  
  submitAbbonamento( { indirizzo, coupon } ) {
    const { abbonamento } = this.props;
    const { } = this.state;
    api({
      method: "POST",
      url: "abbonamento/prePay",
      data: {
        recipient_id: user.id,
        recipient_type: 'docente',
        prodotto: abbonamento.id,
        indirizzo
      },
      appActions: true
    });
  }
  
  async submitTrial( ) {
    const { abbonamento } = this.props;
    const { } = this.state;
    this.setState({
      trialStatus: "loading"
    });
    const res = await api({
      method: "POST",
      url: "abbonamento/trial",
      data: {
        recipient_id: user.id,
        recipient_type: 'docente',
        prodotto: abbonamento.id,
      },
      appActions: true
    });
    this.setState({
      trialStatus: "active"
    });
    notify( { text: 'Free trial attivato', type: 'success' } );
  }
  
  render() {
    const { abbonamento } = this.props;
    const { phase, focus = "", trialStatus = null, item = null } = this.state;
    
    const swiperParams = {
      slidesPerView: 4,
      spaceBetween: 0,
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 0
        },
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
    }
    
    return (
      <div className="ecommerce_AcquistiScuola">
        <div className="ecommerce_Cover">
          <div>
            <div className="container">
              <h3><strong>Prof </strong> for Business</h3>
              <p>Piani Prof For Business: incrementa la tua visibilità del 90%.<br />
              In cima tra i leader.</p>
            </div>
          </div>
        </div>
        <a id="up" />
        {phase === "INDEX" &&
        <>
        <div className="container">
          <section>
            {user &&
            <header className="chooser">
              {user.thumb &&
              <figure className="avatar"><span className="fit">
                <img src={user.thumb} />
              </span></figure>
              }
              {!user.thumb &&
              <figure className="noavatar">
                <img src="/static/pages/ecommerce/user.png" />
              </figure>
              }
              <span>Ciao <strong>{user.nome}</strong>, fai decollare la tua professione!</span>
            </header>
            }
            {!user &&
            <header className="chooser">
              <div className="no-items">Registrati o autenticati per acquistare i servizi</div>
            </header>
            }
            <div className="products">
            <Swiper {...swiperParams}>
              <div className="product">
                <article className="grey">
                  <h3>Free Prof</h3>
                  <p>
                  Il docente 2.0
                  </p>
                  <div className="price">
                    <div><strong>Gratis</strong> per sempre</div>
                  </div>
                  <div>
                    <a href="#focus" className="btn sm btn-block cancel" onClick={() => this.focus("free")}><span>Scopri</span></a>
                  </div>
                </article>
              </div>
              <div className="product">
                <article className="--babyblue">
                  <h3>Premium Prof</h3>
                  <p>
                  Se pensi di valere di più, dai più valore alla tua candidatura.
                  </p>
                  {!__BETA &&
                  <div className="price">
                    <div><strong>120 crediti</strong> / anno</div>
                    <div><small>&euro;</small> <strong>0,99</strong> / giorno</div>
                  </div>
                  }
                  {__BETA && __TRIAL_DATE &&
                  <div className="price"><strong>GRATIS FINO AL {moment(__TRIAL_DATE).format('DD/MM/YYYY')}</strong></div>
                  }
                  <div>
                    <a href="#focus" className="btn sm btn-block cancel" onClick={() => this.focus("premium")}><span>Scopri</span></a>
                  </div>
                </article>
              </div>
              <div className="product">
                <article className="--acidgreen">
                  <h3>Prof Vetrina</h3>
                  <p>
                  La Tua candidatura nella migliore vetrina multimediale.
                  </p>
                  {!__BETA &&
                  <div className="price">
                    <div>da <strong>10 crediti</strong> / giorno</div>
                  </div>
                  }
                  {__BETA && <div className="price"><strong>COMING SOON</strong></div>}
                  <div>
                    <a href="#focus" className="btn sm btn-block cancel" onClick={() => this.focus("adsp")}><span>Scopri</span></a>
                  </div>
                </article>
              </div>
              <div className="product">
                <article className="--violet">
                  <h3>Prof AD Words</h3>
                  <p>
                  La Tua candidatura in vetta alle ricerche.
                  </p>
                  {!__BETA &&
                  <div className="price">
                    <div>da <strong>10 crediti</strong> / giorno</div>
                  </div>
                  }
                  {__BETA && <div className="price"><strong>COMING SOON</strong></div>}
                  <div>
                    <a href="#focus" className="btn sm btn-block cancel" onClick={() => this.focus("adwords")}><span>Scopri</span></a>
                  </div>
                </article>
              </div>
            </Swiper>
            </div>
          </section>
        </div>
        <a id="focus" />
        {focus &&
        <div className="scrollDown">
          <a href="#focus"><span className="icon-expand_arrow" /></a>
        </div>
        }
        {focus === "free" &&
        <Free />
        }
        {focus === "premium" &&
        <Premium activated={item && item.acquisti && item.acquisti.abbonamento ? true : false} onClick={() => this.continue("ABBONAMENTO")} trialStatus={trialStatus} onTrial={() => this.continue("TRIAL")} />
        }
        {focus === "adsp" &&
        <Adsp onClick={() => this.continue("ADSP", { type: 'ADSP'} )} />
        }
        {focus === "adwords" &&
        <Adwords onClick={() => this.continue("ADSP", { type: 'ADWORDS'} )} />
        }
        </>
        }
        
        {phase === "ABBONAMENTO" &&
        <section>
          <div className="container">
            <OrdineCheckout
              items={[{
                ...abbonamento,
                prezzo: abbonamento.prezzo.docente,
                descrizione: `
                Attivazione: ${Formatters.Date({date:abbonamento.DataInizio})}<br />
                Rinnovo automatico: ${Formatters.Date({date:abbonamento.DataRinnovo})}
                `
              }]}
              onSubmit={(args) => this.submitAbbonamento(args)}
              onBack={() => this.reset()}
            />
            </div>
        </section>
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ecommerce/AcquistiDocente.tsx